import React from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Button,
  ConditionBox,
  DatePickerFieldYm,
  CodeSelect,
} from "components";
import moment from "moment";

const AcruDclaTxnCondition = (props) => {
  const { onClickSearch } = props;

  return (
    <>
      <ConditionBox>
        <Formik
          initialValues={{
            setlDate: moment().add(-1, "days"),
            phydsCorpDiv: "",
            carDiv: "",
          }}
          onSubmit={(values, { setSubmitting }) => {
            const { setlDate, ...rest } = values;
            setSubmitting(true);
            onClickSearch({
              ...rest,
              setlDate: moment(setlDate).format("YYYYMM"),
            });
            setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            setlDate: Yup.date().required().nullable(),
            phydsCorpDiv: Yup.string().required(),
          })}
        >
          {(props) => {
            const {
              values,
              isSubmitting,
              touched,
              errors,
              handleChange,
              handleSubmit,
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="HasTable">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <dl>
                            <dt>
                              발송월<i></i>
                              <span>
                                {errors.setlDate &&
                                  touched.setlDate &&
                                  errors.setlDate}
                              </span>
                            </dt>
                            <dd>
                              <div className="HasDate">
                                <DatePickerFieldYm
                                  name="setlDate"
                                  date={values.setlDate}
                                />
                              </div>
                            </dd>
                          </dl>
                          <dl>
                            <dt>
                              법인구분<i></i>
                              <span>
                                {errors.phydsCorpDiv &&
                                  touched.phydsCorpDiv &&
                                  errors.phydsCorpDiv}
                              </span>
                            </dt>
                            <dd>
                              <CodeSelect
                                codeId="ACRU_DIV"
                                name="phydsCorpDiv"
                                onChange={handleChange}
                                onBlur={handleChange}
                                placeholder={"법인구분 선택"}
                                value={values.phydsCorpDiv}
                              />
                            </dd>
                          </dl>
                          <dl>
                            <dt>구분</dt>
                            <dd>
                              <CodeSelect
                                codeId="CAR_DIV"
                                name="carDiv"
                                onChange={handleChange}
                                onBlur={handleChange}
                                placeholder={"구분 선택"}
                                value={values.carDiv}
                              />
                            </dd>
                          </dl>
                        </td>
                        <td>
                          <Button
                            type="submit"
                            className="inquire"
                            disabled={isSubmitting}
                          >
                            조회하기
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Form>
            );
          }}
        </Formik>
      </ConditionBox>
    </>
  );
};

AcruDclaTxnCondition.propTypes = {};

export default AcruDclaTxnCondition;
